import { Injectable } from '@angular/core';
import {
  NgbDateAdapter,
  NgbDateParserFormatter,
  NgbDateStruct
} from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class CustomNgbDateFormatter extends NgbDateParserFormatter {
  // Format using MM/dd/YYYY
  parse(value: string): NgbDateStruct | null {
    const dateParts = value.split('/');
    if (dateParts.length === 3) {
      const monthParsed = parseInt(dateParts.shift() || '', 10);
      const dayParsed = parseInt(dateParts.shift() || '', 10);
      const yearParsed = parseInt(dateParts.shift() || '', 10);
      if (monthParsed && dayParsed && yearParsed) {
        return { month: monthParsed, day: dayParsed, year: yearParsed };
      }
    }

    return null;
  }

  format(date: NgbDateStruct | null): string {
    if (date) {
      const { day, month, year } = date;
      return `${month.toString().length === 1 ? `0${month}` : month}/${day.toString().length === 1 ? `0${day}` : day}/${year}`;
    }

    return '';
  }
}
